import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useDispatch, useSelector } from "react-redux";
import {
    addPrintDetails,
    editPrintDetails,
    selectPrintDetailsLoading
} from "../../../slices/printDetails";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import { fileArraySchema, MAX_FILE_SIZE, SUPPORTED_FORMATS } from "../../../../pages/appointment-details/common-pre-screen/common";
import { deleteFile, uploadFilesPublic } from "../../../slices/appointment";
import { useState, useEffect } from "react";
import { notify } from "../../../utils/methods/notification";
import {selectBmrAllProductList, fetchProductList} from "../../../slices/onBoardUser";
import { labelTypeList } from "../../../utils/common/utils"

const validationSchema = Yup.object().shape({
    products_id: Yup.array()
    .of(Yup.string()) // Ensure array contains strings
    .min(1, 'At least one product must be selected')
    .required('Product is required'),
    brand_name: Yup.string()
        .min(1, "Brand Name must be between 1–150 characters long")
        .max(255, "Brand Name must be between 1–150 characters long")
        .required("Brand Name is required"),
    organisation_name: Yup.string()
        .max(255, "Organisation Name must be between 1–150 characters long")
        .notRequired(),
    brand_description: Yup.string()
        .notRequired(),
    label_types: Yup.array()
    .of(Yup.string()) // Ensure array contains strings
    .min(1, 'At least one label type must be selected')
    .required('Label type is required'),
    org_description: Yup.string()
        .notRequired(),
    brand_logo: fileArraySchema
        .required('Please upload brand logo')
        .min(1, 'Please upload at least one brand logo'),
    organisation_logo: fileArraySchema
        .notRequired()
});

const PrintDetailsForm = ({ editData = null }) => {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectPrintDetailsLoading);
    const [deleteModal, setDeleteModal] = useState(null);
    const allProductList = useSelector(selectBmrAllProductList)
    const [productOption, setProductOption] = useState([])

    useEffect(() => {
      dispatch(fetchProductList({type:'print'}))
    },[dispatch])
    const initialValues = {
        products_id: editData?.products?.map((it)=>it?.product?.id) ?? [],
        brand_name: editData?.brand_name ?? "",
        label_types: Array.isArray(editData?.label_types) 
            ? editData.label_types.map(item => String(item)) // CONVERT TO STRINGS
            : [],
        organisation_name: editData?.organisation_name ?? "",
        org_description:editData?.org_description ?? "",
        brand_description:editData?.brand_description ?? "",
        brand_logo: editData && editData?.brand_logo ? [editData?.brand_logo] : "",
        organisation_logo: editData && editData?.organisation_logo ? [editData?.organisation_logo] : "",
    };
     useEffect(() => {
      if (!allProductList?.length) return;
    
      /*const selectedProductIds = initialValues?.products_id || [];
    
      const productList = allProductList
        .filter(product => {
          // EDIT case → allow selected products
          if (selectedProductIds.length) {
            return (
              selectedProductIds.includes(product.id) || // show selected
              !product.is_mapped                         // show unused
            );
          }
          // ADD case → only unused products
          return !product.is_mapped;
        })
        .map(product => ({
          value: product.id,
          label: product.name
        }));*/
         const productList = allProductList
        .map(product => ({
          value: product.id,
          label: product.name
        }));
    
      setProductOption(productList);
    }, [initialValues, allProductList]);
    

    const handleSubmit = async (values) => {
        if (editData) {
            await dispatch(editPrintDetails({ data: { ...values,label_types:values?.label_types?.filter((it)=> it != null && it !== "null" && it !== ""),  brand_logo_id: values?.brand_logo[0].id, 
                ...values?.organisation_logo?.length ? {organisation_logo_id: values?.organisation_logo[0]?.id}:{} }, editId: editData.id }));
        } else {
            await dispatch(addPrintDetails({ ...values,label_types:values?.label_types?.filter((it)=>  it != null && it !== "null" && it !== ""), brand_logo_id: values?.brand_logo[0].id, ...values?.organisation_logo?.length ? {organisation_logo_id: values?.organisation_logo[0]?.id}:{} }));
        }
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true,
    });



    const handleUploadFiles = async (e) => {
        const { name, files } = e.target;
        const AllFiles = Array.from(files);
        if (formik.values[name].length == 0) {
            if (AllFiles?.length != 0) {
                const validFiles = AllFiles.filter(
                    (file) =>
                        SUPPORTED_FORMATS.includes(file?.type || file?.file_type) &&
                        (file?.size <= MAX_FILE_SIZE || file?.file_size <= MAX_FILE_SIZE)
                );

                if (files.length > 0 && validFiles.length === 0) {
                    formik.setFieldError(
                        name,
                        "Files must be supported format and under 25MB"
                    );
                    return;
                }

                const formData = new FormData();
                validFiles.forEach((file) => {
                    formData.append(name, file);
                });
                const res = await dispatch(
                    uploadFilesPublic({ data: formData })
                );
                if (res?.payload?.data) {
                    const fileValues = formik.values[name];
                    const existingFiles = fileValues || [];
                    formik.setFieldValue(name, [...existingFiles, ...res.payload.data]);
                }
            }
        } else {
            notify.error(`please remove ${name} first`)
        }
    };

    const hanldeRemoveFiles = async () => {
        const res = await dispatch(deleteFile(deleteModal?.id));
        if (res?.payload?.status === 200) {
            const currentFiles = formik.values[deleteModal?.name] || [];
            const updatedFiles = currentFiles.filter(
                (file) => file?.id !== deleteModal?.id
            );
            formik.setFieldValue(deleteModal?.name, updatedFiles);
        }
        setDeleteModal(null);
    };


    const formOptions = [
         {
            label: "Products",
            type: "select",
            name: "products_id",
            multiple:true,
            required: true,
            options: productOption,
            placeholder: "Select Products",
        },
        {
            label: "Label Type",
            type: "select",
            name: "label_types",
            multiple:true,
            required: true,
            options: labelTypeList,
            placeholder: "Select Label Type",
        },
        {
            label: "Brand Name",
            type: "text",
            name: "brand_name",
            required: true,
            placeholder: "Enter brand name",
        },
        /*{
            label: "Brand Description",
            type: "textarea",
            name: "brand_description",
            required: false,
            placeholder: "Enter Brand Description",
        },*/
        {
            label: "Organisation Name",
            type: "text",
            name: "organisation_name",
            required: false,
            placeholder: "Enter organisation name",
        },
        {
            label: "Address",
            type: "textarea",
            name: "org_description",
            required: false,
            placeholder: "Enter Address",
        },
        {
            label: "Brand Logo",
            type: "file",
            name: "brand_logo",
            required: true,
            onChange: handleUploadFiles,
            removeFile: (name, id) => {
                setDeleteModal({ name: name, id: id });
            },
            downloadFile: () => formik.values.brand_logo[0]?.file_path,
            placeholder: "Enter brand logo ID",
        },
        {
            label: "Organisation Logo",
            type: "file",
            name: "organisation_logo",
            required: false,
            multiple: false,
            onChange: handleUploadFiles,
            removeFile: (name, id) => {
                setDeleteModal({ name: name, id: id });
            },
            downloadFile: () => formik.values.organisation_logo[0]?.file_path,
            placeholder: "Enter organisation logo ID",
        },
    ];

    return (
        <Box>
            <DeleteModal
                open={deleteModal}
                setClose={setDeleteModal}
                title={"Are you sure you want to Delete File ?"}
                buttonText={"Delete"}
                handleSuccess={hanldeRemoveFiles}
            />
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => (
                        <Grid key={key} item xs={12}>
                            <FormikControl formik={formik} {...props} />
                        </Grid>
                    ))}
                </Grid>

                <Grid container spacing={2} className="mt-3">
                    <Grid item xs={12}>
                        <LoadingButton
                            loading={isLoading}
                            fullWidth
                            type="submit"
                            variant="contained"
                        >
                            {editData ? "Update" : "Submit"}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
};

export default PrintDetailsForm;
